export const ShippingOrder = {
  findAll: {
    url: ["/shippingorder"],
    method: ["GET"]
  },
  findShippingOrderById: {
    url: ["/shippingorder/{id}"],
    method: ["GET"]
  }
};
